/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiJobReprioritizeResponse
 */
export interface ApiJobReprioritizeResponse {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApiJobReprioritizeResponse
     */
    reprioritizationResults?: { [key: string]: string; };
}

export function ApiJobReprioritizeResponseFromJSON(json: any): ApiJobReprioritizeResponse {
    return ApiJobReprioritizeResponseFromJSONTyped(json, false);
}

export function ApiJobReprioritizeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiJobReprioritizeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reprioritizationResults': !exists(json, 'reprioritizationResults') ? undefined : json['reprioritizationResults'],
    };
}

export function ApiJobReprioritizeResponseToJSON(value?: ApiJobReprioritizeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reprioritizationResults': value.reprioritizationResults,
    };
}

